<template>
    <el-dialog :title="$STR('ws_title_warehouse_operation_message_operation_codes_details', '码值详情')" :visible.sync="dialogVisible" @close="closeDialog" :close-on-click-modal="false"  width="40%">
        <div style="width: 100%;overflow-y: auto">
            <div class="codeShowDetail">
                <p style="background-color: #f4f4f4;color: rgb(51, 51, 51)">{{ $STR('TRACING.traceQeury.codeInfo', '码值信息') }}</p>
                <p>
                    <a>{{ $STR('TRACING.traceQeury.codesDiagram', '码值码图') }}</a>
                    <span>{{codeDetailDataFrom.codeMap}}</span>
                </p>
                <p>
                    <a>{{$STR('pd_label_production_plan_product_detail_codes_status', '码值状态') }}</a>
                    <span>{{codeDetailDataFrom.codeStatus}}</span>
                </p>
                <p>
                    <a>{{$STR('pd_label_production_plan_product_detail_inspect', '是否稽查') }}</a>
                    <span>{{codeDetailDataFrom.isChecked}}</span>
                </p>
                <p>
                    <a>{{$STR('pd_label_production_plan_product_detail_super_code', '上级码') }}</a>
                    <span>{{codeDetailDataFrom.higherCodes}}</span>
                </p>
                <p>
                    <a>{{$STR('pd_label_production_plan_product_detail_lower_code', '下级码') }}</a>
                    <span>{{codeDetailDataFrom.lowerCodes}}</span>
                </p>
            </div>
            <div class="codeShowDetail">
                <p style="background-color: #f4f4f4;color: rgb(51, 51, 51)">{{ $STR('ORDER.orderList.info', '商品信息') }}</p>
                <p>
                    <a>{{$STR('pd_label_production_plan_product_detail_brand', '所属品牌') }}</a>
                    <span>{{codeDetailDataFrom.goodsDetail.brandName}}</span>
                </p>
                <p>
                    <a>{{$STR('pd_label_production_plan_product_detail_goods', '商品名称') }}</a>
                    <span>{{codeDetailDataFrom.goodsDetail.goodsName}}</span>
                </p>
                <p>
                    <a>{{$STR('pd_label_production_plan_product_detail_goods_code', '商品编码') }}</a>
                    <span>{{codeDetailDataFrom.goodsDetail.code}}</span>
                </p>
                <p>
                    <a>{{$STR('pd_label_production_plan_product_detail_unit', '计量单位') }}</a>
                    <span>{{codeDetailDataFrom.goodsDetail.unit}}</span>
                </p>
                <p>
                    <a>{{$STR('pd_label_production_plan_product_detail_batch_no', '批次号') }}</a>
                    <span>{{codeDetailDataFrom.goodsDetail.batchId}}</span>
                </p>
                <p>
                    <a>{{$STR('pd_label_production_plan_product_detail_product_factory', '生产工厂') }}</a>
                    <span>{{codeDetailDataFrom.goodsDetail.factoryName}}</span>
                </p>
                <p>
                    <a>{{$STR('pd_label_production_plan_product_detail_product_date', '生产日期') }}</a>
                    <span>{{codeDetailDataFrom.goodsDetail.date}}</span>
                </p>
            </div>
            <div class="codeShowDetail">
                <p style="background-color: #f4f4f4;color: rgb(51, 51, 51)">{{ $STR('pd_label_production_plan_product_detail_Inventory', '库存信息') }}</p>
                <p>
                    <a>{{ $STR('pd_label_production_plan_product_detail_Inventory_status', '库存状态') }}</a>
                    <span>
                        {{codeDetailDataFrom.stockInfo ? codeDetailDataFrom.stockInfo.status === 1 ? $STR('TRACING.traceQeury.stock.status.in', '入库') : $STR('TRACING.traceQeury.stock.status.out', '出库') : ''}}
                    </span>
                </p>
                <p>
                    <a>{{ $STR('TRACING.traceQeury.stock.status.from', '来源仓库') }}</a>
                    <span>{{codeDetailDataFrom.stockInfo.fromWarehouseName}}</span>
                </p>
                <p>
                    <a>{{ $STR('TRACING.traceQeury.stock.status.target', '目标仓库') }}</a>
                    <span @click="showDialogHandle" :class="{'blue-text': isChangeable}">{{codeDetailDataFrom.stockInfo.targetWarehouseName}}</span>
                </p>
            </div>
            <div class="codeLog">
                <p style="background-color: #f4f4f4;color: rgb(51, 51, 51)">{{ $STR('pd_label_production_plan_product_detail_Inventory_operation_record', '操作记录') }}</p>
                <p v-for="(data, index) of codeLogsList" :key="index">
                    <span style="color: rgb(189,189,189)">{{data.time}}</span>
                    <span>{{data.userName}}</span>
                    <span>{{$STR('pd_label_production_plan_product_detail_to', '于')}}</span>
                    <span>{{data.orgName}}</span>
                    <span>{{data.operationType}}</span>
                    <span @click="codeLogClick(data.id)" style="color:#3e8fe4;cursor:pointer"
                                        v-if="showCodeLog(data.operationType)">[关联日志]</span>
                    <span>,</span>
                    <span>{{$STR('pd_label_production_plan_product_detail_geographical_location', '地理位置') +'：'}} {{data.address?data.address:''}}</span>
                </p>
            </div>
        </div>
        <el-dialog class="update-org" :title="$STR('ORDER.applyInfo.goodsDetail.dialog.toOrg', '收货组织')" :visible.sync="showUpdateOrg" :close-on-click-modal="false" append-to-body>
            <div class="goods-tabs">
                <div v-for="(tabs,index) of statusList" :key="index" @click="selectStatus(tabs)" v-bind:class="{active: tabs.id == userSelectStatus.id}" v-if="tabs.flag">{{tabs.name}}</div>
            </div>
            <div class="select-tabs">
                <p>
                    <el-input v-model="searchOrgParam.keyString" placeholder="请输入关键字进行搜索"></el-input>
                    <el-button type="primary" clearable plain @click="getDirectLowerOrg">搜索</el-button>
                    <el-button plain @click="backHigherOrg" v-if="theOriginal.length>0">返回</el-button>
                </p>
                <el-radio-group v-model="updateParam.inWarehouseId">
                    <p v-for="(org, index) of directLowerOrg" :key="index">
                        <el-radio :label="org.warehouseId" @change="selectOrg(org)" class="el-redio-disaplay"
                        style="word-break: break-all;max-width:320px;white-space: normal">
                         <div style="display:block">{{org.orgName}}({{org.warehouseName}})</div>
                        </el-radio>
                        <el-button type="text" @click="toLowerOrg(org)" v-if="isShowArrow()" style="padding-right: 10px">查看下一级</el-button>
                    </p>
                </el-radio-group>
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchOrgParam.current"
                    :page-sizes="[10, 20, 40]" :page-size="searchOrgParam.rows" layout="total, sizes, prev, next, jumper" :total="total">
                </el-pagination>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" plain @click="confirmUpdate">
                    {{$STR('COMMON.common.btn.confirm', '确定')}}
                </el-button>
                <el-button plain @click="showUpdateOrg=false">
                    {{$STR('COMMON.common.btn.cancel', '取消')}}
                </el-button>
            </div>
        </el-dialog>
        <el-dialog title="关联日志" :visible.sync="codeLogVisible"  :close-on-click-modal="false"  append-to-body>
            <div class="dialog-content">
                <el-table :data="codeLogInfo&&codeLogInfo.codesDetails?codeLogInfo.codesDetails:[]">
                     <el-table-column label="码类" :show-overflow-tooltip="true" prop="code">
                        <template slot-scope="scope"><span>{{scope.row.codeInfo.categoryName}}</span></template>
                    </el-table-column>
                    <el-table-column label="码值" :show-overflow-tooltip="true" prop="code">
                        <template slot-scope="scope">
                            <span class="code-item" @click="onCodeLogClick(scope.row.codeInfo.codes)" v-if="scope.row.codeInfo.codes.barCode">
                                {{scope.row.codeInfo.codes.barCode}}
                            </span>
                            <span class="code-item" @click="onCodeLogClick(scope.row.codeInfo.codes)" v-else-if="scope.row.codeInfo.codes.qcc">
                                {{scope.row.codeInfo.codes.qcc.tpid}}
                            </span>
                            <span v-else>
                                {{showCodeFuction(scope.row.codeInfo.codes)}}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
        <div class="dialog-footer" slot="footer">
            <el-button type="primary" plain @click="closeDialog">{{$STR('pd_btn_production_plan_product_detail_finish', '关闭') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {mapState} from 'vuex';
export default {
    computed: {
        orderStockConfig: {
            ...mapState({
                get: state => state.shoppingCart.orderStockConfig
            })
        },
        isChangeable () {
            // 码值的库存状态为“出库”时，才允许修改接收组织
            return this.codeDetailDataFrom.stockInfo.status === 2 && this.userInfo.orgId === this.codeDetailDataFrom.outOrgId &&
                this.codeDetailDataFrom.stockOutNo === null && this.from === 'warehouse';
        }
    },
    created () {
        this.statusList = [];
        this.statusList.push(this.statusMap[3]);
        this.statusList.push(this.statusMap[2]);
        this.statusList.push(this.statusMap[0]);
    },
    data () {
        return {
            dialogVisible: false,
            showUpdateOrg: false, // 选择接受组织仓库
            codeDetailDataFrom: {
                codeMap: '',
                codeStatus: '',
                isChecked: '',
                higherCodes: '',
                lowerCodes: '',
                goodsDetail: '',
                stockInfo: ''
            },
            codeLogsList: [],
            searchOrgParam: {
                rows: 10,
                current: 1,
                orgType: 0,
                keyString: '',
                parentId: '',
                displayFlag: true
            },
            statusList: [],
            statusMap: {
                3: {id: 3, name: this.$STR('ORDER.applyInfo.data.statusList.3', '经销商'), flag: true},
                2: {id: 2, name: this.$STR('ORDER.applyInfo.data.statusList.2', '工厂'), flag: true},
                0: {id: 0, name: this.$STR('ORDER.applyInfo.data.statusList.0', '企业'), flag: true}
            },
            userSelectStatus: {id: 3, name: this.$STR('ORDER.applyInfo.data.statusList.3', '经销商'), flag: true},
            theOriginal: [],
            updateParam: {
                codeId: '',
                inOrgId: '',
                inWarehouseId: ''
            },
            directLowerOrg: [],
            total: 0,
            userInfo: baseStore.getUserInfo(),
            chosenOrg: {},
            codeLogInfo: {},
            codeLogVisible: false
        };
    },
    props: ['visible', 'codeId', 'from'],
    watch: {
        theOriginal (val) {
            this.getDirectLowerOrg();
        },
        visible() {
            if (!this.visible) return;
            if (this.codeId) {
                this.getCodeDetail(this.codeId);
                this.getCodesLogsList(this.codeId);
            } else {
                this.codeDetailDataFrom.codeMap = '';
                this.codeDetailDataFrom.codeStatus = '';
                this.codeDetailDataFrom.isChecked = '';
                this.codeDetailDataFrom.higherCodes = '';
                this.codeDetailDataFrom.lowerCodes = '';
                this.codeDetailDataFrom.goodsDetail = '';
                this.codeDetailDataFrom.stockOutNo = '';
                this.codeDetailDataFrom.outOrgId = '';
                this.codeDetailDataFrom.stockInfo = '';
                this.codeLogsList = [];
            }
            this.dialogVisible = this.visible;
        },
        showUpdateOrg(val) {
            if (!val) return;
            this.searchOrgParam.current = 1;
            this.searchOrgParam.rows = 10;
            this.searchOrgParam.keyString = '';
            this.searchOrgParam.parentId = '';
            this.theOriginal = [];
        }
    },
    methods: {
        backHigherOrg () {
            this.theOriginal.pop();
        },
        // 查看下一级
        toLowerOrg (org) {
            this.clearFilter();
            this.theOriginal.push(org.orgId);
        },
        confirmUpdate () {
            this.showUpdateOrg = false;
            this.updateParam.inOrgId = this.chosenOrg.orgId;
            this.updateParam.inWarehouseId = this.chosenOrg.warehouseId;
            this.updateOrganization();
        },
        selectOrg(org) {
            this.chosenOrg = org;
        },
        isShowArrow () { // 企业 工厂 经销商
            if (this.orderStockConfig.skipLevel === 1 && ([2, 3, 4].indexOf(this.userInfo.roleType) > -1) && this.userSelectStatus.id === 3) {
                return true;
            } else {
                return false;
            }
        },
        clearFilter() {
            this.searchOrgParam.current = 1;
            this.searchOrgParam.keyString = '';
        },
        selectStatus(status) {
            this.clearFilter();
            this.userSelectStatus = status;
            this.getDirectLowerOrg();
        },
        showDialogHandle() {
            if (!this.isChangeable) return;
            this.showUpdateOrg = true;
            console.log(this.statusList);
            for (let tabs of this.statusList) {
                if (this.userInfo.roleType === 2 && tabs.id === 2) {
                    tabs.flag = false;
                } else {
                    tabs.flag = true;
                }
            }
            for (let tabs of this.statusList) {
                if (tabs.flag) {
                    this.userSelectStatus = tabs;
                    break;
                }
            }
            this.getDirectLowerOrg();
        },
        // 获取下级组织
        getDirectLowerOrg() {
            this.searchOrgParam.orgType = this.userSelectStatus.id;
            this.searchOrgParam.parentId = this.theOriginal.length > 0 ? this.theOriginal[this.theOriginal.length - 1] : this.userInfo.roleType === 2 && this.userSelectStatus.id === 3 ? this.userInfo.orgId : '';
            let url = WebApi.order.directLowerOrg;
            // 跨级发货
            if (this.orderStockConfig.skipLevel === 1 && (this.userInfo.roleType === 3 || this.userInfo.roleType === 2)) url = WebApi.order.allLowerOrg;
            // 工厂发货给经销商
            if (this.orderStockConfig.factoryToDealer === 1 && this.userInfo.roleType === 4) url = WebApi.order.factoryAndDealer;
            this.$http.get(url, {
                params: this.searchOrgParam
            }).then(response => {
                this.directLowerOrg = response.data.rows;
                this.total = response.data.total;
            });
        },
        // 修改目标仓库
        updateOrganization () {
            this.updateParam.codeId = this.codeId;
            this.$http({
                url: WebApi.warehouse.updateOrg,
                method: 'post',
                data: this.updateParam
            }).then(response => {
                this.$message({
                    showClose: true,
                    message: response.data.resultCode === '0' ? this.$STR('pd_hint_script_production_plan_production_setting_update_success', '更新成功') : response.data.message,
                    type: response.data.resultCode === '0' ? 'success' : 'error'
                });
                this.getCodeDetail(this.codeId);
            });
        },
        //获取码值详情
        getCodeDetail(codeId) {
            var _self = this;
            //码值操作记录
            _self.getCodesLogsList(codeId);
            //码值详情
            _self.codeDetailVisible = true;
            _self.codeDetailDataFrom.codeMap = '';
            _self.codeDetailDataFrom.codeStatus = '';
            _self.codeDetailDataFrom.isChecked = '';
            _self.codeDetailDataFrom.higherCodes = '';
            _self.codeDetailDataFrom.lowerCodes = '';
            _self.codeDetailDataFrom.goodsDetail = '';
            _self.codeDetailDataFrom.stockOutNo = '';
            _self.codeDetailDataFrom.outOrgId = '';
            _self.$http.get(WebApi.warehouse.codesDetail, {
                params: {
                    // codeId: '6660856942402994176'
                    codeId: codeId
                }
            }).then(_ => {
                if (_.data.success) {
                    if (_.data.data) {
                        let codeDetailData = _.data.data.codeDetailInfo;
                        if (codeDetailData) {
                            if (codeDetailData.codes.qcc) {
                                if (codeDetailData.codes.qcc.tpid) {
                                    _self.codeDetailDataFrom.codeMap = codeDetailData.codes.qcc.tpid + this.$STR('TRACING.traceQeury.codesDiagram.tpid', '(量子云码标准码)');
                                }
                            }
                            if (codeDetailData.codes.barCode) {
                                if (_self.codeDetailDataFrom.codeMap === '') {
                                    _self.codeDetailDataFrom.codeMap = codeDetailData.codes.barCode + this.$STR('TRACING.traceQeury.codesDiagram.barCode', '(条形码)');
                                } else {
                                    _self.codeDetailDataFrom.codeMap = _self.codeDetailDataFrom.codeMap + '、' + codeDetailData.codes.barCode + this.$STR('TRACING.traceQeury.codesDiagram.barCode', '(条形码)');
                                }
                            }
                            if (codeDetailData.codes.virtualCode) {
                                if (_self.codeDetailDataFrom.codeMap === '') {
                                    _self.codeDetailDataFrom.codeMap = codeDetailData.codes.virtualCode + this.$STR('TRACING.traceQeury.codesDiagram.virtualCode', '(虚拟码)');
                                } else {
                                    _self.codeDetailDataFrom.codeMap = _self.codeDetailDataFrom.codeMap + '、' + codeDetailData.codes.virtualCode + this.$STR('TRACING.traceQeury.codesDiagram.virtualCode', '(虚拟码)');
                                }
                            }
                            if (codeDetailData.codes.verifyCode) {
                                if (_self.codeDetailDataFrom.codeMap === '') {
                                    _self.codeDetailDataFrom.codeMap = codeDetailData.codes.verifyCode + this.$STR('TRACING.traceQeury.codesDiagram.verifyCode', '(验证码)');
                                } else {
                                    _self.codeDetailDataFrom.codeMap = _self.codeDetailDataFrom.codeMap + '、' + codeDetailData.codes.verifyCode + this.$STR('TRACING.traceQeury.codesDiagram.verifyCode', '(验证码)');
                                }
                            }
                            if (codeDetailData.codes.customCode) {
                                if (_self.codeDetailDataFrom.codeMap === '') {
                                    _self.codeDetailDataFrom.codeMap = codeDetailData.codes.customCode + this.$STR('TRACING.traceQeury.codesDiagram.customCode', '(自定义码)');
                                } else {
                                    _self.codeDetailDataFrom.codeMap = _self.codeDetailDataFrom.codeMap + '、' + codeDetailData.codes.customCode + this.$STR('TRACING.traceQeury.codesDiagram.customCode', '(自定义码)');
                                }
                            }
                            if (codeDetailData.activated === 0) {
                                _self.codeDetailDataFrom.codeStatus = this.$STR('pd_btn_production_plan_product_detail_inactivated', '初始状态');
                            } else if (codeDetailData.activated === 1) {
                                _self.codeDetailDataFrom.codeStatus = this.$STR('pd_btn_production_plan_product_detail_activated', '激活(已赋码商品)');
                            } else if (codeDetailData.activated === 2) {
                                _self.codeDetailDataFrom.codeStatus = this.$STR('pd_btn_production_plan_product_detail_invalidate', '作废');
                            } else if (codeDetailData.activated === 3) {
                                _self.codeDetailDataFrom.codeStatus = this.$STR('TRACING.traceData.codeData.BLACK', '黑名单');
                            }
                            _self.codeDetailDataFrom.isChecked = codeDetailData.checked === 0 ? this.$STR('pd_label_production_plan_product_detail_inactivated_no', '否') : this.$STR('pd_label_production_plan_product_detail_activated_yes', '是');
                            if (codeDetailData.higherCodes) {
                                let hightIds = '';
                                if (codeDetailData.higherCodes.codeIds) {
                                    for (let item of codeDetailData.higherCodes.codeIds) {
                                        if (hightIds === '') {
                                            hightIds = item;
                                        } else {
                                            hightIds = hightIds + '、' + item;
                                        }
                                    }
                                    _self.codeDetailDataFrom.higherCodes = hightIds;
                                }
                            }
                            if (codeDetailData.lowerCodes) {
                                let lowIds = '';
                                if (codeDetailData.lowerCodes.codeIds) {
                                    for (let item of codeDetailData.lowerCodes.codeIds) {
                                        if (lowIds === '') {
                                            lowIds = item;
                                        } else {
                                            lowIds = lowIds + '、' + item;
                                        }
                                    }
                                    _self.codeDetailDataFrom.lowerCodes = lowIds;
                                }
                            }
                            if (_.data.data.goodsInfo) {
                                _self.codeDetailDataFrom.goodsDetail = _.data.data.goodsInfo;
                            }
                            if (_.data.data.stockInfo) {
                                _self.codeDetailDataFrom.stockInfo = _.data.data.stockInfo;
                            }
                            _self.codeDetailDataFrom.stockOutNo = _.data.data.stockOutNo;
                            _self.codeDetailDataFrom.outOrgId = _.data.data.outOrgId;
                        }
                    }
                }
            });
        },
        //获取操作记录列表
        getCodesLogsList(codeId) {
            var _self = this;
            _self.$http.get(WebApi.warehouse.codeLogs, {
                params: {
                    codeId: codeId
                }
            }).then(_ => {
                _self.codeLogsList = _.data.data.rows;
            });
        },
        //完成
        closeDialog() {
            this.dialogVisible = false;
            this.$emit('close');
        },
        handleSizeChange(val) {
            this.searchOrgParam.rows = val;
            this.getDirectLowerOrg();
        },
        handleCurrentChange(val) {
            this.searchOrgParam.current = val;
            this.getDirectLowerOrg();
        },
        showCodeLog(type) {
            switch (type) {
            case '打包关联':
            case '追加打包':
            case '尾箱关联':
            case '产线采集':
            case '整件替换':
            case '关联替换':
            case '套标入库':
            case '扫码出库':
            case '解除关联':
            case '扫码解绑':
            case '扫码入库':
                return true;
            default:
                return false;
            }
        },
        codeLogClick(id) {
            this.codeLogVisible = true;
            this.$http.get( WebApi.codesManage.getLogAndCodesDetail, {
                params: {
                    id: id
                }
            }).then(response => {
                if (response.data.success) {
                    this.codeLogInfo = response.data.data;
                } else {
                    this.$message({
                        message: response.data.message,
                        type: 'error'
                    });
                }
            });
        },
        showCodeFuction(codes) {
            let code = '';
            if (codes.qcc) {
                code = codes.qcc.tpid;
            } else if (codes.barCode) {
                code = codes.barCode;
            } else if (codes.customCode) {
                code = codes.customCode;
            } else if (codes.verifyCode) {
                code = codes.verifyCode;
            } else if (codes.virtualCode) {
                code = codes.virtualCode;
            }
            return code;
        },
        onCodeLogClick(codes) {
            let code;
            if (codes.barCode) {
                code = codes.barCode;
            } else {
                code = codes.qcc.tpid;
            }
            this.codeLogVisible = false;
            this.dialogVisible = false;
            this.$emit('close');
            this.$emit('getDetailByCode', code);
        }
    }
};
</script>

<style scoped>
    .oper-button{
        padding-top: 10px;
        display: flex;
        justify-content: center;
    }
    .codeShowDetail{
        padding-bottom: 10px;
        border: 1px solid #f4f4f4;
    }
    .codeShowDetail p{
        padding: 5px 10px 5px 10px;
        border: solid #f4f4f4;
        border-width: 0 1px 1px 0;
        display: flex;
    }
    .codeShowDetail a{
        width: 100px;
        font-size: 14px;
        color: rgb(189,189,189);
    }
    .codeShowDetail span{
        font-size: 14px;
        color: rgb(110,110,110);
        overflow-wrap: break-word;
        margin-left: 10px;
    }
    .codeShowDetail .blue-text {
        color: #4a8df0;
    }
    .codeLog{
        margin-bottom: 20px;
        border: 1px solid #f4f4f4;
    }
    .codeLog p{
        font-size: 13px;
        color: rgb(189,189,189);
        padding: 7px 10px 7px 10px;
        border: solid #f4f4f4;
        border-width: 0 1px 1px 0;
    }
    .codeLog span{
        font-size: 13px;
        color: rgb(110,110,110);
        overflow-wrap: break-word;
        margin-right: 5px;
        line-height:2px;
    }
    .update-org .select-tabs .el-radio-group > p {
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .update-org .select-tabs .el-radio-group {
        width: 100%;
    }
    .update-org .goods-tabs{
        width: 100%;
    }
    ::-webkit-scrollbar {
        /*隐藏滚轮*/
        display: none;
    }
    ::-webkit-scrollbar:hover {
        /*隐藏滚轮*/
        /*display: block;*/
    }
    .el-redio-disaplay {
        display: flex;
    }
    .dialog-content {
        width: 100%;
        height:100%;
        overflow-x: hidden;
        overflow-y:scroll;
    }
    .code-item {
        text-decoration:underline;
        cursor:pointer;
    }
</style>



// WEBPACK FOOTER //
// src/views/cloud/production/codeDetailDialog.vue